export default "__VITE_ASSET__BXot6GLv__"